import { DunningBlockReason } from "@/api-schema-enums";

export const DUNNING_BLOCK_REASON_LABEL_KEYS: Record<DunningBlockReason, string> = {
  [DunningBlockReason.Disputed]: "fia:DunningReasonDisputed",
  [DunningBlockReason.Complaint]: "fia:DunningReasonComplaint",
  [DunningBlockReason.DebtorClarification]: "fia:DunningReasonDebtorClarification",
  [DunningBlockReason.Export]: "fia:DunningReasonExport",
  [DunningBlockReason.FinancedVehicles]: "fia:DunningReasonFinancedVehicles",
  [DunningBlockReason.Warranty]: "fia:DunningReasonWarranty",
  [DunningBlockReason.Collection]: "fia:DunningReasonCollection",
  [DunningBlockReason.InsuranceClaimLawsuit]: "fia:DunningReasonInsuranceClaimLawsuit",
  [DunningBlockReason.DownPaymentReceived]: "fia:DunningReasonDownPaymentReceived",
  [DunningBlockReason.Lawyer]: "fia:DunningReasonLawyer",
  [DunningBlockReason.Insurance]: "fia:DunningReasonInsurance",
  [DunningBlockReason.PaymentAgreement]: "fia:DunningReasonPaymentAgreement",
};

export function getDunningBlockReasonOptions(translate: (key: string) => string, language: string) {
  const collator = new Intl.Collator(language);

  return Object.values(DunningBlockReason)
    .map((reason) => ({
      id: reason,
      name: translate(DUNNING_BLOCK_REASON_LABEL_KEYS[reason]),
    }))
    .sort((left, right) => collator.compare(left.name, right.name));
}
